import { ReactNode } from "react";

/**
 * Пошаговые инструкции по подключению каналов.
 * Показываются на странице канала (ChannelDetails) и подсказкой в окне создания канала.
 */

export const CHANNEL_LABELS: Record<string, string> = {
  INSTAGRAM: "Instagram",
  WHATSAPP: "WhatsApp",
  TELEGRAM: "Telegram",
  TEST_SANDBOX: "Тестовая среда",
};

// Одна строка — для окна «Новый канал»
export const CHANNEL_SHORT_HINTS: Record<string, string> = {
  INSTAGRAM: "Директ и комментарии. Нужен профессиональный аккаунт (Бизнес или Автор).",
  WHATSAPP: "Подключение по QR-коду через «Связанные устройства» на телефоне.",
  TELEGRAM: "Бот Telegram. Понадобится токен из @BotFather — это займёт 2 минуты.",
  TEST_SANDBOX: "Проверка ИИ-агента без мессенджеров: вы пишете агенту как клиент.",
};

const Steps = ({ children }: { children: ReactNode }) => (
  <ol className="list-decimal pl-5 flex flex-col gap-1">{children}</ol>
);

export const CHANNEL_GUIDES: Record<string, { title: string; body: ReactNode }> = {
  INSTAGRAM: {
    title: "Как подключить Instagram",
    body: (
      <>
        <Steps>
          <li>
            Аккаунт должен быть <b>профессиональным</b> (Бизнес или Автор). В приложении Instagram:
            Настройки → Тип аккаунта и инструменты → Переключиться на профессиональный аккаунт.
          </li>
          <li>
            Разрешите доступ к сообщениям: Настройки → Сообщения и ответы на истории → Инструменты для
            сообщений (Подключённые инструменты) → включите <b>«Разрешить доступ к сообщениям»</b>.
          </li>
          <li>
            Нажмите <b>«Подключить Instagram»</b> ниже, войдите в нужный аккаунт и разрешите доступ к
            сообщениям и комментариям.
          </li>
          <li>
            После возврата сюда статус станет «Подключено». Напишите в директ с другого аккаунта —
            сообщение появится во «Входящих», и ИИ-агент ответит.
          </li>
        </Steps>
        <div className="mt-2 text-gray-500">
          Названия пунктов меню могут немного отличаться в зависимости от версии приложения.
          Если агент не отвечает — проверьте, что к каналу привязан агент и канал включён.
        </div>
      </>
    ),
  },
  WHATSAPP: {
    title: "Как подключить WhatsApp",
    body: (
      <Steps>
        <li>
          Нажмите <b>«Подключить Whatsapp»</b> ниже — появится QR-код.
        </li>
        <li>
          На телефоне откройте WhatsApp → Настройки → <b>Связанные устройства</b> → Привязать устройство.
        </li>
        <li>Наведите камеру на QR-код. Код обновляется каждые 30 секунд — если не успели, сканируйте новый.</li>
        <li>Статус станет «Подключено». Напишите на этот номер с другого телефона — агент ответит.</li>
      </Steps>
    ),
  },
  TELEGRAM: {
    title: "Как подключить Telegram",
    body: (
      <Steps>
        <li>
          В Telegram откройте <b>@BotFather</b> и отправьте команду <code>/newbot</code>.
        </li>
        <li>Придумайте название бота и его username (должен заканчиваться на «bot»).</li>
        <li>
          BotFather пришлёт <b>токен</b> вида <code>123456789:AAH...</code>. Скопируйте его.
        </li>
        <li>
          Вставьте токен в поле «Token» ниже и нажмите <b>«Подключить Telegram»</b>.
        </li>
        <li>Найдите своего бота в Telegram и напишите ему — агент ответит.</li>
      </Steps>
    ),
  },
  TEST_SANDBOX: {
    title: "Что такое тестовая среда",
    body: (
      <Steps>
        <li>Это канал для проверки ИИ-агента без подключения мессенджеров. В лимит каналов тарифа не входит.</li>
        <li>
          Если канал ещё не подключён — нажмите <b>«Подключить»</b> ниже (к каналу должен быть привязан агент).
        </li>
        <li>
          Откройте ИИ-агенты → ваш агент → <b>Тестовая среда</b>, нажмите «+», введите любое имя клиента и
          первое сообщение.
        </li>
        <li>Агент ответит через несколько секунд. В мессенджерах он отвечает позже: ждёт, пока клиент допишет сообщение.</li>
      </Steps>
    ),
  },
};
